// ============================================================================
// Host Bridge — Types, Interfaces, and Readback Layout Re-exports
// ============================================================================
// RC-03: Extracted from host-bridge.ts to reduce the main file's surface.
// All types are re-exported from host-bridge.ts for backward compatibility.
import { READBACK } from './readback-layout.js';
// --- Readback SAB Layout constants ---
export { READBACK, READBACK_SAB_SIZE, READBACK_FIELDS_DEF } from './readback-layout.js';
export const RB_DIRTY = READBACK.dirty;
export const RB_HAS_SELECTION = READBACK.hasSelection;
export const RB_SEL_X = READBACK.selX;
export const RB_SEL_Y = READBACK.selY;
export const RB_SEL_W = READBACK.selW;
export const RB_SEL_H = READBACK.selH;
export const RB_HAS_TRANSFORM = READBACK.hasTransform;
export const RB_TFM_DATA = READBACK.tfmData;
export const RB_STROKE_ON = READBACK.strokeOn;
export const RB_LAYER_COUNT = READBACK.layerCount;
export const RB_ACTIVE_LAYER = READBACK.activeLayer;
//# sourceMappingURL=host-bridge-types.js.map